/**
 * VGS Form configuration constants
 */

export const VGS_FORM_DEFAULTS = {
  DO_SHOW_SECURITY_CODE_INPUT: true,
  DO_TAKE_CARD_ADDRESS_INPUTS: true,
};

export const VGS_FIELD_CSS = {
  BASE: {
    boxSizing: 'border-box',
    lineHeight: '1.2em',
    fontSize: '15px',
    fontWeight: '300',
    border: 'none',
    color: '#31325F',
    width: '100%',
    height: '100%',
    '&::placeholder': {
      color: '#CFD7E0',
    },
  },
};

export const VGS_FIELD_IDS = {
  CARD_NUMBER: 'card-number',
  CARD_EXPIRY: 'card-expiry',
  CARD_CVC: 'card-cvc',
  CARD_NAME: 'card-name',
  ADDRESS: 'address',
};

export const VGS_MOBILE_BREAKPOINT = 1300;

export const VGS_FIELD_ERRORS = {
  cardNumber: 'Invalid or missing card number',
  expiration: 'Invalid or missing expiry date',
  cardHolderName: 'Cardholder name required',
  cvc: 'Invalid security code',
};

export default {
  VGS_FORM_DEFAULTS,
  VGS_FIELD_CSS,
  VGS_FIELD_IDS,
  VGS_MOBILE_BREAKPOINT,
  VGS_FIELD_ERRORS,
};
